export default "__VITE_ASSET__9bdb51d1__"